export default __webpack_public_path__ + "static/invest-public-health-healthcare-accomplishment-3c-361bd7880abc0a69829d3046801446e3.webp";